import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import Usuario from "../../page/usuarios/Usuario";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const UsuarioController = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [provincias, setProvincias] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(null);

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "aplicar":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${usuario.id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            //return navigate(`/dashboard/cupones/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "guardar":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${value}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            return navigate(`/dashboard/usuarios/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      //case "rol":
      case "provincia":
      case "localidad":
      case "direccion":
      case "apellido":
      case "nombre":
        {
          setUsuario({
            ...usuario,
            [e.target.name]: e.target.value
          })
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!usuario && id) {
      return fetch(setUsuario, {}, `/usuarios/${id}`);
    }
  }, [id]);

  useEffect(() => {
    if (!provincias) {
      return fetch(setProvincias, {}, `/provincias`);
    }
  }, []);

  if (!usuario || !provincias) {
    return "";
  }

  return (
    <Usuario
      data={usuario}
      provincias={provincias}
      onClick={onClick}
      onChange={onChange}
    />
  );
};

export default UsuarioController;
